<template>
  <div class="animated fadeIn">
    <b-row class="downloads-filter-row">
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-info">
          <b-card-body>
            <div v-if="!filteredResults">
              <h4 class="mb-0">{{ filesInSystem ? filesInSystem.toLocaleString() : 0 }}</h4>
              <p>Files</p>
            </div>
            <div v-if="filteredResults">
              <h4 class="mb-0">{{filesFilteredCount}} of {{ filesInSystem ? filesInSystem.toLocaleString() : 0 }}</h4>
              <p>Files</p>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="6">
        <b-card no-body class="bg-info">
          <b-card-body>
            <h4 class="mb-0">Search</h4>
            <p>By name</p>
            <b-input-group>
              <b-form-input @keyup="updateSearch()" v-model="textboxFilterValue" placeholder="Type to Search" />
              <b-input-group-addon>
                <b-btn :disabled="!filter" @click="resetSearchFilter()">Clear</b-btn>
              </b-input-group-addon>
            </b-input-group>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
      <b-row>
      <b-col sm="12">
        <div>
          <b-btn v-b-toggle.collapse1 variant="primary">Filters</b-btn>
          <b-btn @click="resetFilters">Clear Filters</b-btn>
          <b-collapse id="collapse1" class="mb-30">
            <b-card>
              <b-row>
                <b-col sm="4">
                  <b-form-group
                    label="File Type" label-for="fileType"
                  >
                    <b-form-select class="mb-2 mr-sm-2 mb-sm-0"
                      id="fileType"
                      v-model="dropdownFilterValue"
                      :options="filterOptions"
                      @change="updateFilter()"
                      :style="{ width: '150px' }"
                    >
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-collapse>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-20">
      <b-col sm="12">
        <b-card>
          <b-table
              v-show="finishedLoading"
              :filter="filter"
              :filter-function="searchFilter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="onFiltered" :hover="true"
              :striped="true"
              :bordered="false"
              :small="true"
              :fixed="true"
              responsive="sm"
              :items="files"
              :fields="getTableFields()"
              :per-page="20"
              :current-page="currentPage">
              <div slot="fileName" class="" slot-scope="item">
                <a :href="item.item.filePath" download>{{item.value}}</a>
              </div>
              <div slot="startDate" class="" slot-scope="item">
                {{item.item.context}}
              </div>
          </b-table>
          <b-pagination :total-rows="6" prev-text="Prev" next-text="Next" :current-page="currentPage" v-model="currentPage"></b-pagination>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'downloads',
    computed: {
      ...mapGetters({
        files: 'getFiles',
        finishedLoading: 'getFileResponse',
        filesInSystem: 'getFileRecordCount'
      })
    },
    data: function () {
      return {
        sortBy: 'startDate',
        sortDesc: true,
        sortDirection: 'desc',
        filteredResults: false,
        filesFilteredCount: 0,
        filter: null,
        isDropdownFilter: false,
        dropdownFilterValue: null,
        textboxFilterValue: null,
        currentPage: 1,
        filterOptions: [
          { value: null, text: 'Choose...' },
          { value: 'CSE-IT Texas (Monthly)', text: 'CSE-IT Texas (Monthly)' },
          { value: 'CSE-IT WCC (Monthly)', text: 'CSE-IT WCC (Monthly)' }
        ],
        tableFields: [
          {
            key: 'fileName',
            label: 'File',
            class: '',
            sortable: true
          },
          {
            key: 'fileType',
            label: 'File Type',
            sortable: true
          },
          {
            key: 'startDate',
            label: 'Date Range',
            sortable: true
          }
        ]
      }
    },
    methods: {
      getTableFields () {
        var fields = this.tableFields
        return fields
      },
      resetSearchFilter () {
        this.textboxFilterValue = null
        this.filter = null
        this.filteredResults = false
      },
      resetFilters () {
        this.isDropdownFilter = false
        this.dropdownFilterValue = null
        this.filteredResults = false
        this.filter = null
      },
      updateSearch () {
        this.isDropdownFilter = false
        this.filter = this.textboxFilterValue
      },
      updateFilter () {
        this.isDropdownFilter = true
        this.textboxFilterValue = null
        this.filter = this.dropdownFilterValue
      },
      searchFilter (originalRecord) {
        let foundMatch = false
        let stringSearches = []
        this.filteredResults = true

        if (this.isDropdownFilter) {
          stringSearches = [ 'fileType' ]

          if (this.filter === null) {
            return true
          }

          let filter = this.filter.toLowerCase()

          _.forEach(stringSearches, element => {
            let field = originalRecord[element]

            if (_.isString(field) && field !== '') {
              field = field.toLowerCase()
              if (originalRecord[element].toLowerCase().indexOf(filter) >= 0) {
                foundMatch = true
              }
            }
          })

          // Eject before date check
          if (foundMatch) {
            return foundMatch
          }
        } else {
          stringSearches = [ 'fileName' ]

          if (this.filter === null) {
            return true
          }

          let filter = this.filter.toLowerCase()

          _.forEach(stringSearches, element => {
            let field = originalRecord[element]

            if (_.isString(field) && field !== '') {
              field = field.toLowerCase()
              if (originalRecord[element].toLowerCase().indexOf(filter) >= 0) {
                foundMatch = true
              }
            }
          })

          // Eject before date check
          if (foundMatch) {
            return foundMatch
          }
        }

        return foundMatch
      },
      getRowCount (items) {
        return items.length
      },
      onFiltered (filteredItems) {
        this.totalRows = filteredItems.length
        this.filesFilteredCount = filteredItems.length
        this.currentPage = 1
      }
    },
    created: function () {
      this.$store.dispatch('getFiles')
      this.$store.dispatch('getFileRecordCount')
    }
  }
</script>

<style scoped>
  .downloads-filter-row{
    margin-bottom: 30px;
  }
  .downloads-filter-row .card{
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
</style>


// WEBPACK FOOTER //
// src/views/pages/Downloads.vue